import 'zone.js';

import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

async function bootstrap(): Promise<void> {
  if (location.hostname === 'localhost') {
    const { startMockWorker } = await import('./app/dev-mock/msw-worker');
    await startMockWorker();
  }
  await platformBrowserDynamic().bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection()],
  });
}

bootstrap().catch(err => console.error(err));
